<template>
  <ValidatePreBet />
</template>
<script>
import ValidatePreBet from "@/components/agent/validatePreBet/validatePreBet";
export default {
  components: {
    ValidatePreBet,
  },
};
</script>
